<template>
  <div class="features-list">
    <feature
      v-for="feature in features.filter((feature) => {
        return feature.group && featureGroupIds.includes(feature.group._id)
        })"
      v-model="value"
      :key="feature._id"
      :field="field"
      :feature="feature"
    />
  </div>
</template>

<script>
import Feature from './Feature'

export default {
  name: 'FeaturesFromGroup',

  components: {
    Feature
  },

  data () {
    return {
      moduleName: 'features',
      module: {},
      features: []
    }
  },

  computed: {
    modules () {
      return this.$store.getters.modules
    }
  },

  props: {
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },

    parentModuleName: {
      type: String,
      default: null
    },

    featureGroupIds: {
      type: Array,
      default: () => {
        return []
      }
    },

    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  created () {
    if (this.modules[this.moduleName]) {
      this.module = this.modules[this.moduleName]
      let useFeaturesFrom = this.modules[this.parentModuleName].useFeaturesFrom
      if (useFeaturesFrom) {
        this.features = this.$store.getters['moduleListLinkItems'][useFeaturesFrom].features
      }
    }
  }
}
</script>

<style>
.features-list .v-input--hide-details {
  margin-top: 0 !important;
  padding-top: 4px !important;
}
</style>
